import { render, staticRenderFns } from "./inquireForm.vue?vue&type=template&id=58af6eff&scoped=true&"
import script from "./inquireForm.vue?vue&type=script&lang=js&"
export * from "./inquireForm.vue?vue&type=script&lang=js&"
import style0 from "./inquireForm.vue?vue&type=style&index=0&id=58af6eff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af6eff",
  null
  
)

export default component.exports